import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil, withLatestFrom, filter } from 'rxjs/operators';
import * as fromComm from 'src/app/modules/communications/store/communications';
import { ConfiguredChannel } from 'src/app/modules/communications/store/communications/communications.model';
import { cloneDeep } from 'lodash-es';
import { GUID_EMPTY } from '@app/core/constants';
import { ChannelUIds } from 'src/app/modules/management/store/communication-center';
import { CommunicationsApiService } from '@app/modules/communications/store/communications/communications-api.service';
import { QueryParams } from '@app/modules/core/store/models/query.model';

@Component({
  selector: 'horizon-sms-edit',
  templateUrl: './horizon-sms-edit.component.html',
  styleUrls: ['./horizon-sms-edit.component.scss'],
  standalone: false
})
export class HorizonSmsEditComponent implements OnInit, OnDestroy {
  @Input() isActive: boolean;
  configuredChannel: ConfiguredChannel;
  destroy$ = new Subject<void>();
  emptyGuid = GUID_EMPTY;
  hasTwillioChannel: boolean;

  constructor(
    private store: Store<fromComm.State>,
    private translate: TranslateService,
    private communicationsApiService: CommunicationsApiService
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromComm.selectHorizonSmsEditIsActive)
      .pipe(takeUntil(this.destroy$))
      .subscribe(isActive => (this.isActive = isActive));

    this.store
      .select(fromComm.selectSelectedConfiguredChannel)
      .pipe(
        withLatestFrom(this.store.select(fromComm.selectHorizonSmsEditIsActive)),
        filter(([, isActive]) => isActive),
        takeUntil(this.destroy$)
      )
      .subscribe(([selectedChannel, isActive]) => {
        this.configuredChannel = !!selectedChannel ? cloneDeep(selectedChannel) : null;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.store.dispatch(fromComm.closeConfiguredChannelEdit());
  }

  cancelClick(): void {
    this.close();
  }

  saveClick(): void {
    this.store.dispatch(fromComm.saveConfiguredChannelToApi({ channel: this.configuredChannel }));
  }
}
